import { View, Text, StyleSheet, Modal, TouchableOpacity } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

interface Props {
  visible: boolean;
  onPost: () => void;
  onSkip: () => void;
}

export default function PostOptionModal({ visible, onPost, onSkip }: Props) {
  const { theme } = useTheme();

  return (
    <Modal visible={visible} animationType="slide" transparent>
      <View style={styles.modalOverlay}>
        <View style={[styles.postOptionModal, { backgroundColor: theme.colors.surface }]}>
          <Text style={[styles.postOptionTitle, { color: theme.colors.text }]}>
            Workout Saved!
          </Text>
          <Text style={[styles.postOptionDescription, { color: theme.colors.textSecondary }]}>
            Share your progress with the community
          </Text>
          <View style={styles.postOptionButtons}>
            <TouchableOpacity
              style={[styles.postOptionButton, { backgroundColor: theme.colors.accent }]}
              onPress={onPost}>
              <Text style={[styles.postOptionButtonText, { color: theme.colors.accentForeground }]}>
                Post to Feed
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.postOptionButton, { backgroundColor: theme.colors.surfaceVariant }]}
              onPress={onSkip}>
              <Text style={[styles.postOptionButtonText, { color: theme.colors.textSecondary }]}>
                Skip
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.8)',
    justifyContent: 'flex-end',
  },
  postOptionModal: {
    borderRadius: 2,
    padding: 24,
    margin: 20,
    alignItems: 'center',
  },
  postOptionTitle: {
    fontSize: 24,
    fontWeight: '800',
    marginBottom: 8,
    textAlign: 'center',
  },
  postOptionDescription: {
    fontSize: 16,
    marginBottom: 24,
    textAlign: 'center',
  },
  postOptionButtons: {
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  postOptionButton: {
    paddingVertical: 16,
    borderRadius: 0,
    alignItems: 'center',
  },
  postOptionButtonText: {
    fontSize: 16,
    fontWeight: '700',
  },
});
